module.exports = __webpack_public_path__ + "img/bilakh.61e7c7a5.svg";